import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Banner = styled.div<{ src?: string }>`
  position: relative;
  background-color: ${(props) => props.theme.color.blue.default};
  color: ${(props) => props.theme.color.light.default};
  padding: 15px 0;
  padding-bottom: 20px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);

  ${(props) =>
    props.src &&
    `
  background: url(${props.src}) no-repeat center center;
  background-size: cover;

  &::after {
    content: ""; 
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: rgba(0, 0, 0, 0.3);
  }
  `}
`;

export const DecorationImage = styled.img`
  position: absolute;
  right: 0px;
  top: 0;
  bottom: 0;
  top: 10px;
  right: 10px;
  height: 100%;
  ${mediaQuery('tablet')} {
    display: none;
  }
`;

export const Title = styled.div`
  z-index: 1;
  position: relative;
  text-align: left;
  font-family: ${(props) => props.theme.font.alternate};
  margin-bottom: 8px;
  text-transform: none;
  font-weight: 600;
  ${responsiveFontSize(35)}
`;

export const Subtitle = styled.div`
  z-index: 1;
  position: relative;
  text-align: left;
  margin-bottom: 8px;
  font-weight: 400;
  ${responsiveFontSize(30, 2)}
`;
